import useBinding from "./binding/useBinding";
import { useTemplateIdentity } from "./utils/useTemplateIdentify";
import { parseHTML, queryAllChilds } from "./util";
import { checkIsComponent } from "../plugins/useDefineComponent";
import useWeakMap from "../utils/useWeakMap";
import useDiscard from "../useDiscard";
import { checkIsCustomComponent } from "./utils/useMarkIsCustomComponent";

const reNodeListIfComponent = (nodeList, targetNode) => {
    const cachingNode = new Set(Array.from(nodeList));
    const childs = new Set(Array.from(queryAllChilds(targetNode)));
    childs.forEach((item) => {
        cachingNode.delete(item);
    })
    return Array.from(cachingNode);
}

const groupNodes = (node) => {
    const childs = queryAllChilds(node);
    const output = childs.reduce((output, child) => {
        if (checkIsComponent(child)) {
            return output;
        }

    }, []);
    console.log("output", output);
}


const useTemplateBuilder = (() => {
    const caching = useWeakMap();

    const onDiscardProps = props => caching.delete(props);

    const bindTempate = async (rootElement, props) => {
        let allNodes = [rootElement]
        if (rootElement instanceof HTMLElement) {
            allNodes = allNodes.concat(queryAllChilds(rootElement));
        }
        // let allNodes = queryAllChilds(rootElement);
        // allNodes.unshift(rootElement);

        while (allNodes.length > 0) {
            const node = allNodes.shift();
            if (checkIsCustomComponent(node) && rootElement !== node) {
                allNodes = reNodeListIfComponent(allNodes, node);
            }
            if (node instanceof HTMLElement) {
                await useBinding(props, node)
            }
        }
    }

    return async ({ rootElement, template, props = {}, templateName = '' }, onloaded = () => { }) => {

        if (caching.has(props) && caching.get(props) === rootElement) {
            return;
        }
        if (rootElement instanceof HTMLElement && typeof template === 'string' && template.length > 0) {
            const d = document.createElement('div');
            d.innerHTML = template;
            while (d.childNodes.length > 0) {
                rootElement.appendChild(d.childNodes[0]);
            }
        }
        useTemplateIdentity(props, null, templateName);
        if (Array.isArray(rootElement)) {
            for (let i = 0; i < rootElement.length; i++) {
                await bindTempate(rootElement[i], props);
            }
        } else {
            await bindTempate(rootElement, props);
        }
        caching.set(props, rootElement);
        useDiscard(props, onDiscardProps)
        onloaded();
    }
})();

export default useTemplateBuilder;